if (typeof updateBusinessDate !== 'function') {
  function updateBusinessDate() {
    const INVENTORY_MESSAGE_CLASS = '.js-inventory-message'
    const INVENTORY_MESSAGE_WRAP_CLASS = '.js-inventory-wrap'
    const INVENTORY_MESSAGE_CART_CLASS = '.js-inventory-message-cart'
    const INVENTORY_ICON_CLASS = '.js-inventory-icon'
    const BUSINESS_DAYS_TEXT = 'business days'
    const BUSINESS_DAY_TEXT = 'business day'
    const WEEKS_TEXT = 'weeks'
    const SPECIAL_TEXT = 'Special Event'
    const ENGRAVING_TEXT = 'Engraving'
    const DISPATCH_NEXT_DAY = 'Estimated dispatch:'
    const DISPATCH_SAME_DAY = 'Same day dispatch'
    const DISPATCH_SAME_DAY_CLASS = 'ProductForm__Inventory--same-day'
    let inventoryMessageDefault = ''
    let _addingEngraving = window.addingEngraving;

    // Redefine the addingEngraving property with getters and setters
    Object.defineProperty(window, 'addingEngraving', {
      get: function() {
        return _addingEngraving;
      },
      set: function(newValue) {
        _addingEngraving = newValue;
        formatReadyWord(); // Run the formatReadyWord function when value changes
      }
    });

    const dataExcludeDates = EXCLUDE_DATES.map(date => date.trim()).filter(date => date)

    const inventoryMessageEl = document.querySelector(INVENTORY_MESSAGE_CLASS)
    const inventoryWrapEl = document.querySelector(INVENTORY_MESSAGE_WRAP_CLASS)
    const inventoryIcon = document.querySelector(INVENTORY_ICON_CLASS)

    const isExcludeDate = (currentDate) => {
      if (!dataExcludeDates.length) {
        return false
      }
      return dataExcludeDates.some(date => date === currentDate.toLocaleDateString("en-GB", { month: '2-digit', day: '2-digit' }))
    }

    // CDSD-27910 logic needs to be copied over to formatDate.ts
    const addAddBusinessDay = (number) => {
      const currentDate = new Date()
      let isExclude = false
      for (let i = 1; i <= number; i++) {
        if (number === 1) {
          if(!isExclude) currentDate.setDate(currentDate.getDate() + 1);

          if(isExcludeDate(currentDate)) isExclude = false

          if (currentDate.getDay() === 6) {
            currentDate.setDate(currentDate.getDate() + 2);
          } else if (currentDate.getDay() === 0) {
            currentDate.setDate(currentDate.getDate() + 1);
          }
          if (isExcludeDate(currentDate)) {
            i--;
            isExclude = true
            currentDate.setDate(currentDate.getDate() + 1);
          }
        } else {
          currentDate.setDate(currentDate.getDate() + 1);
          if (currentDate.getDay() === 6) {
            currentDate.setDate(currentDate.getDate() + 2);
          } else if (currentDate.getDay() === 0) {
            currentDate.setDate(currentDate.getDate() + 1);
          }
          if (isExcludeDate(currentDate)) {
            i--;
          }
        }
      }
      return currentDate
    }

    const getBusinessDay = (timeText) => {
      let dayBusiness = 0
      timeText = timeText.trim()
      if (timeText.indexOf(SPECIAL_TEXT) >= 0) {
        dayBusiness = parseInt(EVENT_TIME)
      } else if (timeText.indexOf(ENGRAVING_TEXT) >= 0) {
        dayBusiness = parseInt(ENGRAVING_TIME)
      } else if (timeText.indexOf(BUSINESS_DAYS_TEXT) >= 0) {
        dayBusiness = parseInt(timeText.substring(0, timeText.indexOf(BUSINESS_DAYS_TEXT)))
      } else if (timeText.indexOf(BUSINESS_DAY_TEXT) >= 0) {
        dayBusiness = parseInt(timeText.substring(0, timeText.indexOf(BUSINESS_DAY_TEXT)))
      } else if (timeText.indexOf(WEEKS_TEXT) >= 0) {
        dayBusiness = parseInt(timeText.substring(0, timeText.indexOf(WEEKS_TEXT))) * 5
      }
      return dayBusiness
    }

    const nthNumber = (number) => {
      if (number > 3 && number < 21) return 'th'
      switch (number % 10) {
        case 1:
          return 'st'
        case 2:
          return 'nd'
        case 3:
          return 'rd'
        default:
          return 'th'
      }
    }

    const formatDate = (date) => {
      const weekday = date.toLocaleString('default', { weekday: 'long' })
      const day = date.getDate()
      const month = date.toLocaleString('default', { month: 'long' })
      return `${weekday}, ${month} ${day}${nthNumber(day)}`
    }

    const formatReadyWord = (el = inventoryMessageEl, isAddingEngraving = window.addingEngraving) => {
      const date = new Date()
      const hourSydney = date.toLocaleString('en-GB', {hour: '2-digit', timeZone: 'Australia/Sydney'})
      inventoryWrapEl?.classList.remove(DISPATCH_SAME_DAY_CLASS)
      if (hourSydney < SAME_DAY_HOUR_CUTOFF) {
        inventoryMessageDefault = DISPATCH_SAME_DAY
        if (inventoryIcon) {
          inventoryIcon.style.display = 'none'
        }
        inventoryWrapEl?.classList.add(DISPATCH_SAME_DAY_CLASS)
      } else {
        const dateAdded = addAddBusinessDay(1)
        inventoryMessageDefault = DISPATCH_NEXT_DAY + ' ' + formatDate(dateAdded)

        if (inventoryIcon) {
          inventoryIcon.style.display = 'none'
        }
      }

      if (isAddingEngraving) {
        const productionTimeStringFromTag = window.productionTime;
        const numberOfDaysToProduce = parseInt(productionTimeStringFromTag.split(' ')[0]);
        const dateAdded = addAddBusinessDay(numberOfDaysToProduce)
        inventoryMessageDefault = MADE_ORDER_WORDING + ' ' + formatDate(dateAdded)
        window.dispatchDate = dateAdded
        el && (el.innerHTML = inventoryMessageDefault)
        el && el.classList.add('active')
        inventoryWrapEl?.classList.add('active')
      } else {
        el && (el.innerHTML = inventoryMessageDefault)
        el && el.classList.add('active')
        inventoryWrapEl?.classList.add('active')
      }
    }

    const updateProductionTimePdp = () => {
      if (inventoryMessageEl) {
        const inventoryMessage = inventoryMessageEl.innerHTML.trim()

        if (inventoryMessage === inventoryMessageDefault) {
          return
        }

        if (inventoryMessage === READY_WORDING) {
          if (inventoryIcon) {
            inventoryIcon.style.display = 'block'
          }
          formatReadyWord()

          return
        }

        if (inventoryMessage.includes(READY_WORDING)) {
          if (inventoryIcon) {
            inventoryIcon.style.display = 'block'
          }
          formatReadyWord()
        } else {
          if (inventoryIcon) {
            inventoryIcon.style.display = 'none'
          }
        }

        const timeText = inventoryMessage.replace(MADE_ORDER_WORDING, '')
        const dayBusiness = getBusinessDay(timeText)
        inventoryMessageDefault = inventoryMessage

        if (dayBusiness > 0) {
          const dateAdded = addAddBusinessDay(dayBusiness)
          inventoryMessageDefault = `${inventoryMessageEl.dataset.archiveSale === 'true' ? MADE_SHIPPING_WORDING : MADE_ORDER_WORDING} ${formatDate(dateAdded)}`
          inventoryMessageEl.innerHTML = inventoryMessageDefault
          inventoryWrapEl.classList.add('active')
          window.dispatchDate = dateAdded
        }
      }
    }

    document.addEventListener('variant:changed', () => {
      const stones = document.querySelectorAll('[data-pendant-stone]').length
      if (stones <= 1 || !inventoryMessageEl) return

      const dayBusiness = getBusinessDay(window.productionTime)
      if (dayBusiness > 0) {
        const dateAdded = addAddBusinessDay(dayBusiness)
        inventoryMessageDefault = `${inventoryMessageEl.dataset.archiveSale === 'true' ? MADE_SHIPPING_WORDING : MADE_ORDER_WORDING} ${formatDate(dateAdded)}`
        inventoryMessageEl.innerHTML = inventoryMessageDefault
        inventoryWrapEl.classList.add('active')
        window.dispatchDate = dateAdded
      }
    })

    const updateProductNotice = () => {
      const notice = document.querySelector('.ProductMeta__Text')
      const labels = Array.prototype.slice.call(document.querySelectorAll('[data-pendant-count] .HorizontalList__Item'))
      if (!notice || !labels) {
        return
      }
      if (labels.length && notice) {
        labels.forEach(label => {
          label.addEventListener('click', () => {
            const number = label.querySelector("label").innerHTML
            if (number === '1') {
              notice.style.display = 'none'
            } else {
              notice.style.display = 'block'
            }
          })
        })
      }
    }

    const addMutationObserver = () => {
      const config = { attributes: false, childList: true, subtree: false }
      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          if (mutation.type === 'childList') {
            updateProductionTimePdp()
            updateProductNotice()
          }
        }
      }
      const observer = new MutationObserver(callback)
      observer.observe(inventoryMessageEl, config)
    }

    const getLongestProductionTime = () => {
      try {
        let lineItems = document.querySelector('[data-engravingDispatchTimes-json]')
        if (!lineItems) { return null }
        lineItems = lineItems.innerHTML
        lineItems = JSON.parse(lineItems)
        let maxDate = null
        lineItems.engravingDispatchTimes.forEach((item) => {
          if (item['_EstimatedDispatch']) {
            let date = new Date(item['_EstimatedDispatch'])
            if (!maxDate) {
              maxDate = date
            } else if (date > maxDate) {
              maxDate = date
            }
          }
        })
        return maxDate
      } catch (error) {
        console.warn('error', error)
        return null
      }
    }

    const updateProductionTimeCart = (isAddingEngraving) => {
      let maxDate = getLongestProductionTime()
      const inventoryMessageCartEls = document.querySelectorAll(INVENTORY_MESSAGE_CART_CLASS)
      if (!inventoryMessageCartEls.length) return

      inventoryMessageCartEls.forEach(el => {
        el.classList.add('active')
        const longestFixedDate = el.dataset.isoDate
        const maxFixedDate = longestFixedDate ? new Date(longestFixedDate) : null
        const inventoryMessage = el.innerHTML
        const timeText = inventoryMessage.replace(MADE_SHIPPING_WORDING, '').trim()

        if (timeText === READY_WORDING && !longestFixedDate) {
          formatReadyWord(el, isAddingEngraving)
          return
        }

        if (timeText === DISPATCH_SAME_DAY && !longestFixedDate) {
          return
        }

        const dayBusiness = getBusinessDay(timeText)
        const dateAdded = addAddBusinessDay(dayBusiness)
        const calculatedDate = maxFixedDate && (maxFixedDate.getTime() > dateAdded.getTime())
          ? maxFixedDate
          : dateAdded

        if (!dayBusiness && !calculatedDate) {
          el.innerHTML = ''
          return
        }

        if (maxDate) {
          el.innerHTML = MADE_SHIPPING_WORDING + ' ' + formatDate(maxDate)
        } else {
          el.innerHTML = MADE_SHIPPING_WORDING + ' ' + formatDate(calculatedDate)
        }
      })
    }

    const updateCartAttrInput = () => {
      const messageElement = document.querySelector(INVENTORY_MESSAGE_CART_CLASS)
      if (!messageElement) return

      const message = messageElement.textContent
      const input = document.querySelector('[name="attributes[production-time]"]')
      if (!input || !message) return

      input.value = message
    }

    const addMutationObserverCart = (target) => {
      const config = { attributes: false, childList: true, subtree: false }
      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          if (mutation.type === 'childList') {
            updateProductionTimeCart()
            updateCartAttrInput()
          }
        }
      }
      const observer = new MutationObserver(callback)
      observer.observe(target, config)
    }

    if (inventoryMessageEl) {
      updateProductionTimePdp()
      addMutationObserver()
    }

    const cartEls = document.querySelectorAll('[data-section-type="cart"]')
    if (cartEls.length > 0) {
      cartEls.forEach(cartEl => addMutationObserverCart(cartEl))
    }

    document.addEventListener('cart:rendered', (e) => {
      const { items } = e.detail

      const isAddingEngraving = items.some(item => item.properties?._engravedProduct)

      setTimeout(() => {
        updateProductionTimeCart(isAddingEngraving)
        updateCartAttrInput()
      }, 200)
    })

    updateProductNotice()
  }
}

updateBusinessDate()
